import { render, staticRenderFns } from "./costConfig.vue?vue&type=template&id=27622af8&"
import script from "./costConfig.vue?vue&type=script&lang=js&"
export * from "./costConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports